import uniqueItems from '../helpers/unique-items';
/**
 @abstract
 */
class MultiArgsFilter {
    constructor(element, parent) {
        if (this.constructor === MultiArgsFilter) {
            throw new Error("Abstract classes can't be instantiated.");
        }
        this.parent = parent;
        this.element = element;
    }

    getFilterArgs() {
        if (this.filterType === 'taxonomy') {
            return this.parent.filterArgs.taxonomy[this.filterTaxonomySlug];
        }

        if (this.filterType === 'content_type') {
            return this.parent.filterArgs.content_type;
        }

        return [];
    }

    hasFilterArgs() {
        if (this.filterType === 'taxonomy') {
            if (
                !this.parent.filterArgs.taxonomy ||
                !Object.keys(this.parent.filterArgs.taxonomy).length ||
                !this.parent.filterArgs.taxonomy[this.filterTaxonomySlug] ||
                !this.parent.filterArgs.taxonomy[this.filterTaxonomySlug].length
            ) {
                return false;
            }
        }

        if (this.filterType === 'content_type' && !this.parent.filterArgs.content_type?.length) {
            return false;
        }

        return true;
    }

    updateFilterArgs(slug, isActive) {
        if (isActive) {
            this.removeItem(slug);
        } else {
            this.addItem(slug);
        }
    }

    addItem(slug) {
        if (this.filterType === 'taxonomy') {
            this.addTerm(this.filterTaxonomySlug, slug);
        } else if (this.filterType === 'content_type') {
            this.addContentType(slug);
        }
    }

    addContentType(option) {
        if (!this.parent.filterArgs.content_type) {
            this.parent.filterArgs.content_type = [];
        }
        this.parent.filterArgs.content_type = uniqueItems(this.parent.filterArgs.content_type, [option]);
    }

    addTerm(slug, option) {
        if (!this.parent.filterArgs.taxonomy) {
            this.parent.filterArgs.taxonomy = {};
        }

        if (this.parent.filterArgs.taxonomy[slug]) {
            this.parent.filterArgs.taxonomy[slug] = uniqueItems(this.parent.filterArgs.taxonomy[slug], [option]);
        } else {
            this.parent.filterArgs.taxonomy[slug] = [option];
        }
    }

    removeItem(slug) {
        if (this.filterType === 'taxonomy') {
            this.removeTerm(this.filterTaxonomySlug, slug);
        } else if (this.filterType === 'content_type') {
            this.removeContentType(slug);
        }
    }

    removeTerm(slug, option) {
        if (this.parent.filterArgs.taxonomy[slug]) {
            this.parent.filterArgs.taxonomy[slug] = this.parent.filterArgs.taxonomy[slug].filter(
                (termSlug) => termSlug !== option
            );
        }

        if (this.parent.filterArgs.taxonomy[slug]?.length === 0) {
            delete this.parent.filterArgs.taxonomy[slug];
        }
    }

    removeContentType(option) {
        this.parent.filterArgs.content_type = this.parent.filterArgs.content_type.filter(
            (contentSlug) => contentSlug !== option
        );
    }

    // eslint-disable-next-line class-methods-use-this
    clear() {
        throw new Error("Method 'clear()' must be implemented.");
    }

    // eslint-disable-next-line class-methods-use-this
    updateInitialValues() {
        throw new Error("Method 'updateInitialValues()' must be implemented.");
    }

    // eslint-disable-next-line class-methods-use-this
    changeState() {
        throw new Error("Method 'changeState()' must be implemented.");
    }

    // eslint-disable-next-line class-methods-use-this
    registerEvents() {
        throw new Error("Method 'registerEvents()' must be implemented.");
    }

    // eslint-disable-next-line class-methods-use-this
    get filterTaxonomySlug() {
        throw new Error("Method 'getFilterTaxonomySLug()' must be implemented.");
    }

    // eslint-disable-next-line class-methods-use-this
    get filterType() {
        throw new Error("Method 'filterType()' must be implemented.");
    }
}

export default MultiArgsFilter;
